import { render } from "./EntityManagement.vue?vue&type=template&id=1aa83094&scoped=true"
import script from "./EntityManagement.vue?vue&type=script&lang=js"
export * from "./EntityManagement.vue?vue&type=script&lang=js"

import "./EntityManagement.vue?vue&type=style&index=0&id=1aa83094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa83094"]])

export default __exports__